<template>
  <div class="row mt-4">
    <div class="col-xl-12 mb-3">
      <h2 class="ml-3">Métriques des délais d'opérations à partir du {{ date_recuperation }}</h2>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/nbre_patients'>
                <h5 class="card-title text-uppercase text-muted mb-0">Nombre de patients sur la base de calcul</h5>
                <span class="h2 font-weight-bold mb-0">{{ nbre_patients }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/temps_moyen'>
                <h5 class="card-title text-uppercase text-muted mb-0">Temps moyen de prise en charge</h5>
                <span class="h2 font-weight-bold mb-0">{{ temps_moyen }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/affiliation_et_affectation_medecin_referents'>
                <h5 class="card-title text-uppercase text-muted mb-0">Temps moyen entre l'affiliation et l'affectation du medécin reférent</h5>
                <span class="h2 font-weight-bold mb-0">{{ affiliation_et_affectation_medecin_referents }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/activite_amas'>
                <h5 class="card-title text-uppercase text-muted mb-0">Délai des Activités Administratives</h5>
                <span class="h2 font-weight-bold mb-0">{{ activite_amas }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/medecin_controle'>
                <h5 class="card-title text-uppercase text-muted mb-0">Délai des Activités Médécins référents</h5>
                <span class="h2 font-weight-bold mb-0">{{ medecin_controle }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/avis_medicals'>
                <h5 class="card-title text-uppercase text-muted mb-0">Temps moyen de Réponses aux avis médicaux émis</h5>
                <span class="h2 font-weight-bold mb-0">{{ avis_medicals }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/consultation_examen_validation'>
                <h5 class="card-title text-uppercase text-muted mb-0">Temps moyen de la validation du souscripteur</h5>
                <span class="h2 font-weight-bold mb-0">{{ consultation_examen_validation }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/consultation_medecine_generale'>
                <h5 class="card-title text-uppercase text-muted mb-0">Délai moyen de Consultation médécine générale</h5>
                <span class="h2 font-weight-bold mb-0">{{ consultation_medecine_generale }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/consultation_fichier'>
                <h5 class="card-title text-uppercase text-muted mb-0">Délai de production des rapports après consultations</h5>
                <span class="h2 font-weight-bold mb-0">{{ consultation_fichier }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/resultat_imagerie'>
                <h5 class="card-title text-uppercase text-muted mb-0">Temps moyen d'ajout des résultats d'imageries</h5>
                <span class="h2 font-weight-bold mb-0">{{ resultat_imagerie }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/resultat_labo'>
                <h5 class="card-title text-uppercase text-muted mb-0">Temps moyen d'ajout des résultats de laboratoires</h5>
                <span class="h2 font-weight-bold mb-0">{{ resultat_labo }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/taux_rendez_vous'>
                <h5 class="card-title text-uppercase text-muted mb-0">Taux de rendez-vous honoré</h5>
                <span class="h2 font-weight-bold mb-0">{{ taux_rendez_vous }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/evolutions/all_patients'>
                <h5 class="card-title text-uppercase text-muted mb-0">Nombre total de patients</h5>
                <span class="h2 font-weight-bold mb-0">{{ all_patients }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/evolutions/all_souscripteurs'>
                <h5 class="card-title text-uppercase text-muted mb-0">Nombre total de souscripteurs</h5>
                <span class="h2 font-weight-bold mb-0">{{ all_souscripteurs }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 mb-3">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <router-link to='prise-charge/evolutions/all_praticiens'>
                <h5 class="card-title text-uppercase text-muted mb-0">Nombre total de praticiens</h5>
                <span class="h2 font-weight-bold mb-0">{{ all_praticiens }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Vue from 'vue';
import _ from "lodash";
import AppConfig from "../../constants/AppConfig";
import router from "../../router/router";
export default {
  name: "prise-charge",
  computed: {
    ...mapGetters(["notif_validation_prix", 'hasAdminRole', 'hasGestionnaireRole', 'hasPraticienRole', 'hasMedecinControleRole'])
  },
  data(){
    return {
      date_recuperation: Date(),
      temps_moyen: 0,
      nbre_patients: 0,
      activite_amas: 0,
      affiliation_et_affectation_medecin_referents: 0,
      consultation_examen_validation: 0,
      consultation_fichier: 0,
      consultation_medecine_generale: 0,
      medecin_controle: 0,
      resultat_imagerie: 0,
      resultat_labo: 0,
      avis_medicals: 0,
      taux_rendez_vous: "0%",
      all_patients: 0,
      all_souscripteurs: 0,
      all_praticiens: 0
    }
  },
  methods: {
    TempsPriseEnCharge(){
      fetch(AppConfig.apiUrl+`/v1/metriques`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
      .then(res => {
        if(res.status == 401){
          localStorage.setItem('ancestor_link', window.location.href);
          router.push({ name: 'login' });
          Vue.swal({type: 'error', title: error.message});
        }
        return res.json()
      })
      .then(res => {
        this.temps_moyen = res.temps_moyen;
        this.nbre_patients = res.nbre_patients;
        this.activite_amas = res.activite_amas;
        this.affiliation_et_affectation_medecin_referents = res.affiliation_et_affectation_medecin_referents;
        this.consultation_examen_validation = res.consultation_examen_validation;
        this.consultation_fichier = res.consultation_fichier;
        this.consultation_medecine_generale = res.consultation_medecine_generale;
        this.medecin_controle = res.medecin_controle;
        this.resultat_imagerie = res.resultat_imagerie;
        this.resultat_labo = res.resultat_labo;
        this.temps_moyen = res.temps_moyen;
        this.avis_medicals = res.avis_medicals;
        this.date_recuperation = res.date_recuperation;
        this.taux_rendez_vous = res.taux_rendez_vous;
        this.all_patients = res.all_patients;
        this.all_souscripteurs = res.all_souscripteurs;
        this.all_praticiens = res.all_praticiens;
        //metrique
      }).catch(error => {})
    }
  },
  mounted() {
    this.TempsPriseEnCharge();
  }
}
</script>

<style scoped>

</style>